export default __webpack_public_path__ + "static/media/napaPrivilegeLogo_fr.2702b169.svg";